/* eslint-disable no-restricted-syntax */
export function scrollToEl(el, offset) {
	const bodyBounds = document.body.getBoundingClientRect();
	const elBounds = el.getBoundingClientRect();
	const header = document.getElementById('js-site-header');
	const top = elBounds.top - bodyBounds.top - header.offsetHeight;

	window.scroll({
		behavior: 'smooth',
		left: 0,
		top: top - offset,
	});
}

export function weightCalc(adders, unit) {
	let calc = 0;

	if (unit === 'lb') {
		calc = adders.reduce((total, adder) => total + adder, 0);
	} else {
		calc = Math.round(adders.reduce((total, adder) => total + adder, 0) * 0.453592);
	}

	return calc;
}

export function validOption(option) {
	return (
		option.classList.contains('selectable')
		&& !option.classList.contains('single-option')
		&& !option.classList.contains('active')
	);
}
